export default __webpack_public_path__ + "media/images/blank_page_dirty-f89d590152b6f36c0938fb943cc014db.gif";